module.exports = __webpack_public_path__ + "static/img/1.f831b12.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/eng/1.png
// module id = jT3J
// module chunks = 0